package com.milta.feature.ocrscan.domain.entity

/**
 * Response of `POST /api/v1/ocr-scans` — a single synchronous Claude Vision call, no session, no
 * server-side attempt tracking (see `ScanDeliveryListCommand` on the backend). [incompleteCount] is
 * the backend's own count; the presentation layer recomputes it live off [deliveries] as the driver
 * corrects rows (screen C/D of the mockup), it is not re-read after the initial scan.
 */
data class OcrScanResult(
    val totalCount: Int,
    val incompleteCount: Int,
    val deliveries: List<ScannedDelivery>,
)
